import { call, put, takeLatest } from 'redux-saga/effects';
import { apiCallStatus } from 'helpers/constants';
import logger from 'helpers/logger';
import BulkUpload from 'api/BulkUploadApi/bulkUpload';
import { actionTypes } from './constants';

// Action creators (optional, if you use getApiActionCreator)
const getBulkUploadStatus = (status, data, error) => {
    return {
        type: actionTypes.GET_BULK_UPLOAD_STATUS,
        status,
        data,
        error,
    };
};
const getBulkUploadSasUrl = (status, data, error) => ({
    type: actionTypes.GET_BULK_UPLOAD_SAS_URL,
    status,
    data,
    error,
});
const startBulkUpload = (status, data, error) => ({
    type: actionTypes.START_BULK_UPLOAD,
    status,
    data,
    error,
});

// 1. Get Bulk Upload Status
function* getBulkUploadStatusSaga({ assetId, startDate, endDate }) {
    try {
        yield put(getBulkUploadStatus(apiCallStatus.LOADING));
        const response = yield call(BulkUpload.getBulkUploadStatusV2, assetId, startDate, endDate);
        logger.debug('Bulk upload status loaded', assetId, startDate, endDate);
        yield put(getBulkUploadStatus(apiCallStatus.SUCCESS, response));
    } catch (err) {
        yield put(getBulkUploadStatus(apiCallStatus.ERROR, null, err));
    }
}

// 2. Get SAS URL
function* getBulkUploadSasUrlSaga({ assetId, filename }) {
    try {
        yield put(getBulkUploadSasUrl(apiCallStatus.LOADING));
        const response = yield call(BulkUpload.getBulkUploadSasUrl, assetId, filename);
        logger.debug('Bulk upload SAS URL loaded', assetId, filename);
        yield put(getBulkUploadSasUrl(apiCallStatus.SUCCESS, response));
    } catch (err) {
        yield put(getBulkUploadSasUrl(apiCallStatus.ERROR, null, err));
    }
}

// 3. Start Bulk Upload
function* startBulkUploadSaga({ assetId, bulkUploadFiles, startDate, endDate }) {
    try {
        yield put(startBulkUpload(apiCallStatus.LOADING));
        const response = yield call(BulkUpload.startBulkUpload, assetId, bulkUploadFiles);
        logger.debug('Bulk upload started', assetId, bulkUploadFiles);
        yield put(startBulkUpload(apiCallStatus.SUCCESS, response));
        const statusResponse = yield call(BulkUpload.getBulkUploadStatusV2, assetId, startDate, endDate);
        yield put(getBulkUploadStatus(apiCallStatus.SUCCESS, statusResponse));
    } catch (err) {
        yield put(startBulkUpload(apiCallStatus.ERROR, null, err));
    }
}

export function* bulkUploadRequestWatchers() {
    yield takeLatest(actionTypes.GET_BULK_UPLOAD_STATUS_REQUEST, getBulkUploadStatusSaga);
    yield takeLatest(actionTypes.GET_BULK_UPLOAD_SAS_URL_REQUEST, getBulkUploadSasUrlSaga);
    yield takeLatest(actionTypes.START_BULK_UPLOAD_REQUEST, startBulkUploadSaga);
}
